<template>
  <b-row class="base-row-padded">
    <b-col>
      <h2>Batch Group Creation via Excel</h2>
      <b-card>
        <b-form-group label="Upload Excel File">
          <b-form-file v-model="file" :state="Boolean(file)" placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..." accept=".xlsx, .xls"></b-form-file>
        </b-form-group>
        <b-button variant="primary" :disabled="!file || formLoading" @click="handleUpload">
          Upload & Process
        </b-button>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import groupsMixin from './groupsMixin';
import formsMixin from '@/mixins/forms';

export default {
  mixins: [groupsMixin, formsMixin],
  data() {
    return {
      file: null,
    }
  },
  mounted() {
    if (sessionStorage.getItem('group_excel_suggestions')) {
      this.$router.push({ name: 'groupExcelProcess' });
    }
  },
  methods: {
    handleUpload() {
      if (!this.file) return;
      const formData = new FormData();
      formData.append('devices', this.file);

      this.uploadExcel(formData).then(data => {
        // Converting to array for easier processing
        // data.groups is { [name]: devices[] }
        const suggestions = Object.entries(data.groups).map(([name, devices]) => ({ name, devices }));

        sessionStorage.setItem('group_excel_suggestions', JSON.stringify(suggestions));
        this.$router.push({ name: 'groupExcelProcess' });
      });
    }
  }
}
</script>
